(function () {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'search': {
            	method: 'GET',
            	url: 'api/_search/users',
            	isArray: true
            }
        });

        return service;
    }
})();
